/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ITileListItemViewProps } from '@msdyn365-commerce-modules/tile-list';

//----------------------------------------------------------
// @CUSTOM: Custom imports
//----------------------------------------------------------
import classnames from 'classnames';
import { ITileListItemProps } from '../definition-extensions/tile-list-item.ext.props.autogenerated';
//----------------------------------------------------------

/**
 *
 * ITileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
const renderTileListItemContent = (props: ITileListItemViewProps & ITileListItemProps<{}>): JSX.Element => {    // @CUSTOM: Added extended props
    const {
        heading,
        paragraph,
        backgroundImage,
        links,
        thumbnailImage,
        tileListContainer,
        tileListImageContainer,
        tileListThumbnailImageContainer,
        tileListHeadingContainer
    } = props;

    return (
        // @CUSTOM: Added config classnames since OOTB module was not set up to do so
        <Node {...tileListContainer} className={classnames(tileListContainer.className, props.config.className)}>
            <Node {...tileListImageContainer}>{backgroundImage}</Node>
            <Node {...tileListHeadingContainer}>
                {heading}
                {paragraph}
                {links}
            </Node>
            <Node {...tileListThumbnailImageContainer}>{thumbnailImage}</Node>
        </Node>
    );
};

/**
 *
 * TileListItemViewProps component.
 * @param props - Component props.
 * @returns TileListView.
 */
export const TileListItemViewComponent: React.FC<ITileListItemViewProps & ITileListItemProps<{}>> = props => {    // @CUSTOM: Added extended props
    const { tileListItem } = props;
    return <Module {...tileListItem}>{renderTileListItemContent(props)}</Module>;
};

export default TileListItemViewComponent;
